
import FinancialAdminService from '../../../../../services/financeadmin.service'

export default {
  getAllMonthlyCrossAccts: context => {
    context.commit('setLoadingMCA', true)
    console.log('############## action: getAllMonthlyCrossAccts ####################')
    FinancialAdminService.getAllMonthlyCrossAccts((res, err) => {
      if (err) {

      } else {
        context.commit('setLoadingMCA', false)
        console.log('+++++++++++++++++++++++')
        console.log(res)
        console.log('+++++++++++++++++++++++')
        context.commit('setMonthlyCross', res)
      }
    })
  },
  processAWSMonthlyBilling: (context, billingParam) => {
    let response_text = null
    context.commit('setLoadingMCA', true)
    FinancialAdminService.processAWSBilling(billingParam, (res, err) => {
      if (err) {
        response_text = err
      } else {
        console.log('res: ' + res)
        context.commit('setbillingProcessStatus', res)
      }
      // context.commit('setSnackbar', {
      //     show: true, type: 'primary', timeout: 20000,
      //     message: response_text, buttons: false
      //   }, { root: true }
      // )
      context.commit('setLoadingMCA', false)  
    })
    
  }
}
